// extracted by mini-css-extract-plugin
export default {"section":"CA-z","sectionTitle":"DA-z","fieldWrapper":"EA-z","formField":"FA-z","disabled":"GA-z","formLabel":"HA-z"};